module.exports = __webpack_public_path__ + "img/xhs01.ba4e38c1.png";